import React from 'react'
import LeftBlock from './LeftBlock'
import RightBlock from './RightBlock'


const Home = () => {
  return (
    <>
      <section className='home vh-100 d-flex'>
        <LeftBlock />
        <RightBlock />
      </section> 
    </>
  );
};

export default Home;